import React, { useState, useEffect, useCallback } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import ReactTooltip from 'react-tooltip';
import moment from 'moment';
import Currency from 'react-currency-formatter';
import attachDocument from '../../../../layout/Logistic/Attachment';
import Loading from '~/components/layout/Loading';
import { analytics, logEvent } from '~/services/firebaseConfig';
import { useSelector } from 'react-redux';
import {
  Container,
  Title,
  Left,
  Middle,
  Right,
  Details,
  IconInformationBlue,
  IconPix,
  ToolTipText,
  ToolTipButton,
  ImageDiv
} from './styles';
import informationBlue from '~/assets/images/information-blue.svg';
import pix from '~/assets/images/pix-blue.svg';

export default function MobilePayDebt({ data, openModal, handleShowButton }) {

  const [fileAttached, setFileAttached] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [selectedPixCode, setSelectedPixCode] = useState("")

  const logisticPaymentReducer = useSelector(state => state.logisticPaymentReducer);

  useEffect(()=>{
    if(data && data.amountRemaining > 0 && data.paymentStatus === 'OP') {
      handleShowButton({id: data.invoice.invoiceId, status:fileAttached })
    }
  },[fileAttached])

  const handleCopyToClickBoard = useCallback((selectedPixCode) => {
    logEvent(analytics, "copiando_linha_digitavel");
    setSelectedPixCode(selectedPixCode);
  },[selectedPixCode]);


  let qrcodeData = null
  try {
    if ('qrcodeData' in data) {
      qrcodeData = JSON.parse('{' + data?.qrcodeData + '}');
    }
  } catch (error) {
    console.log('Erro ao converter QRCode');
  }

  return (
    data && data.amountRemaining > 0 && data.paymentStatus === 'OP' && (
      <Container className="mb-3">
        <Left>
          <Title style={{ fontSize: 14 }}>
            {moment(data.dueDate).format("MMMM/YYYY")}
          </Title>
        </Left>
        {qrcodeData?.dados_qrcode?.emv && (
          <CopyToClipboard text={qrcodeData?.dados_qrcode?.emv}>
            <ToolTipButton
              onClick={() => {
                handleCopyToClickBoard(qrcodeData?.dados_qrcode?.emv)
              }}
              data-tip
              data-for={data.invoice.invoiceId}
            >
              <img src={pix} style={IconPix} alt="Pix" />
            </ToolTipButton>
          </CopyToClipboard>
        )}
        {selectedPixCode === qrcodeData?.dados_qrcode?.emv ? (
          <ReactTooltip
            id={data.invoice.invoiceId}
            place="right"
            type="dark"
            effect="solid"
          >
            <ToolTipText>Copiado</ToolTipText>
          </ReactTooltip>
        ) : (
          <ReactTooltip
            id={data.invoice.invoiceId}
            place="right"
            type="dark"
            effect="solid"
          >
            <ToolTipText>Clique para copiar</ToolTipText>
          </ReactTooltip>
        )}
        <ImageDiv
          onClick={() => openModal()
          }>
          <img src={informationBlue} style={IconInformationBlue} alt="Info Icon" />
        </ImageDiv>
        <Right>
          <Title>
            <Currency quantity={data.amountOriginal} currency="BRL" locale="pt" />
          </Title>
          {isLoading ? (
            <Loading margin={"0px"} />
          ) : (
            <Details
              color={fileAttached}
              onClick={() => {
                attachDocument(logisticPaymentReducer.order.id, setFileAttached, setIsLoading);
              }}
            >
              Anexar comprovante
            </Details>
          )}
        </Right>
      </Container>
    )
  );
}
